/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StationRouteImport } from './routes/station'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSearchRouteImport } from './routes/_authenticated.search'
import { Route as AuthenticatedQueueRouteImport } from './routes/_authenticated.queue'
import { Route as AuthenticatedPendingRouteImport } from './routes/_authenticated.pending'
import { Route as AuthenticatedFlashRouteImport } from './routes/_authenticated.flash'
import { Route as AuthenticatedCheckinRouteImport } from './routes/_authenticated.checkin'
import { Route as AuthenticatedHotelExitsTicketIdRouteImport } from './routes/_authenticated.hotel-exits.$ticketId'

const StationRoute = StationRouteImport.update({
  id: '/station',
  path: '/station',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQueueRoute = AuthenticatedQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPendingRoute = AuthenticatedPendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFlashRoute = AuthenticatedFlashRouteImport.update({
  id: '/flash',
  path: '/flash',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCheckinRoute = AuthenticatedCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHotelExitsTicketIdRoute =
  AuthenticatedHotelExitsTicketIdRouteImport.update({
    id: '/hotel-exits/$ticketId',
    path: '/hotel-exits/$ticketId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/station': typeof StationRoute
  '/checkin': typeof AuthenticatedCheckinRoute
  '/flash': typeof AuthenticatedFlashRoute
  '/pending': typeof AuthenticatedPendingRoute
  '/queue': typeof AuthenticatedQueueRoute
  '/search': typeof AuthenticatedSearchRoute
  '/hotel-exits/$ticketId': typeof AuthenticatedHotelExitsTicketIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/station': typeof StationRoute
  '/checkin': typeof AuthenticatedCheckinRoute
  '/flash': typeof AuthenticatedFlashRoute
  '/pending': typeof AuthenticatedPendingRoute
  '/queue': typeof AuthenticatedQueueRoute
  '/search': typeof AuthenticatedSearchRoute
  '/hotel-exits/$ticketId': typeof AuthenticatedHotelExitsTicketIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/station': typeof StationRoute
  '/_authenticated/checkin': typeof AuthenticatedCheckinRoute
  '/_authenticated/flash': typeof AuthenticatedFlashRoute
  '/_authenticated/pending': typeof AuthenticatedPendingRoute
  '/_authenticated/queue': typeof AuthenticatedQueueRoute
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/_authenticated/hotel-exits/$ticketId': typeof AuthenticatedHotelExitsTicketIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/station'
    | '/checkin'
    | '/flash'
    | '/pending'
    | '/queue'
    | '/search'
    | '/hotel-exits/$ticketId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/station'
    | '/checkin'
    | '/flash'
    | '/pending'
    | '/queue'
    | '/search'
    | '/hotel-exits/$ticketId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/station'
    | '/_authenticated/checkin'
    | '/_authenticated/flash'
    | '/_authenticated/pending'
    | '/_authenticated/queue'
    | '/_authenticated/search'
    | '/_authenticated/hotel-exits/$ticketId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  StationRoute: typeof StationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/station': {
      id: '/station'
      path: '/station'
      fullPath: '/station'
      preLoaderRoute: typeof StationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/queue': {
      id: '/_authenticated/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof AuthenticatedQueueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pending': {
      id: '/_authenticated/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof AuthenticatedPendingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flash': {
      id: '/_authenticated/flash'
      path: '/flash'
      fullPath: '/flash'
      preLoaderRoute: typeof AuthenticatedFlashRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/checkin': {
      id: '/_authenticated/checkin'
      path: '/checkin'
      fullPath: '/checkin'
      preLoaderRoute: typeof AuthenticatedCheckinRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotel-exits/$ticketId': {
      id: '/_authenticated/hotel-exits/$ticketId'
      path: '/hotel-exits/$ticketId'
      fullPath: '/hotel-exits/$ticketId'
      preLoaderRoute: typeof AuthenticatedHotelExitsTicketIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCheckinRoute: typeof AuthenticatedCheckinRoute
  AuthenticatedFlashRoute: typeof AuthenticatedFlashRoute
  AuthenticatedPendingRoute: typeof AuthenticatedPendingRoute
  AuthenticatedQueueRoute: typeof AuthenticatedQueueRoute
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedHotelExitsTicketIdRoute: typeof AuthenticatedHotelExitsTicketIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCheckinRoute: AuthenticatedCheckinRoute,
  AuthenticatedFlashRoute: AuthenticatedFlashRoute,
  AuthenticatedPendingRoute: AuthenticatedPendingRoute,
  AuthenticatedQueueRoute: AuthenticatedQueueRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedHotelExitsTicketIdRoute: AuthenticatedHotelExitsTicketIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  StationRoute: StationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
